export const SUCCESSFUL_GET_ACCOUNT  = "SUCCESSFUL_GET_ACCOUNT";
export const SUCCESSFUL_GET_ACCOUNT_BALANCE  = "SUCCESSFUL_GET_ACCOUNT_BALANCE";


// WEBPACK FOOTER //
// ./src/reducers/account/actionConst.js